export default {
  searchClassUserSchool: '',
  searchClassUserLevel: '',
  searchClassUserFacult: ''
}



// WEBPACK FOOTER //
// ./src/components/class-users/store/state.js